module.exports = __webpack_public_path__ + "static/media/PERFECT_logo_newcolor.ff00d06d.svg";